<!--
   Created by qing on 2021/1/18
   Des: 拉起小程序页面
-->
<template>
  <div class="forward-page" v-wechat-title="$store.getters.webName" v-if="isWexin">
    <img :src="loginBgImage" alt="" class="login-image">
    <div class="title">
      欢迎您使用{{$store.getters.webName}}
    </div>
    <div class="sub-title">
      您第一次使用时，需要进行账户初始化
    </div>
    <div class="footer">
      <van-button
        type="default"
        class="app-btn"
        round
        @click="onClickApp">
        应用中心
      </van-button>
      <van-button
        v-if="!isWxWork && !isLark && !isWexin"
        type="primary"
        round
        @click="onClickLogin">
        登录/注册
      </van-button>
      <div class="weapp-btn" v-if="isWexin">
        <wx-open-launch-weapp
          id="launch-weapp1"
          :username="originalAppId"
          path="pages/index/index.html"
          @launch="onLaunch"
          @error="onError"
        >
          <script type="text/wxtag-template">
            <div
              style="border-radius: 20px;font-size: 14px; text-align: center; color: #fff; background-color: #4A66FA;border: 1px solid #4A66FA; height: 44px; line-height: 44px;width: 150px;">
              登录/注册
            </div>
          </script>
        </wx-open-launch-weapp>
      </div>
    </div>

  </div>
</template>

<script>
  import {ENV_TYPE_SMALLPROGRAM} from "../store/types";
  import {originalAppId, login_bg_image} from "../../assets/js/base_config";
  import {
  	isUndefined,
  	formatDate
  } from "../../assets/js/Untis";
  
  import {
  	BrowserType
  } from "../../assets/js/browserType";

  export default {
    data() {
      return {
        copyInput: null,
        isWxWork: false,
        isLark: false,
        isWexin: false,
        login_bg_image: '',
        originalAppId: ''
      }
    },
    created() {
      this.$store.dispatch('setPageTitle', this.$store.getters.webName)
      this.originalAppId = originalAppId()
      this.login_bg_image = this.$store.getters.configMap.logoBgUrl

      this.copyInput = document.createElement('input')
      this.copyInput.setAttribute('type', 'text')
      this.copyInput.readOnly = 'readOnly';
      this.copyInput.contentEditable = 'true';
      this.copyInput.style.position = 'absolute';
      this.copyInput.style.top = document.body.scrollTop;
      this.copyInput.style.zIndex = '-1000';
      document.body.appendChild(this.copyInput);

      this.isWxWork = window.isWxWork
      this.isLark = window.isLark

      if (!window.isWexin) {
		  // 添加utm参数
		  const {
		  	utm_source,
		  	utm_name,
		  	utm_content
		  } = this.$route.query;
		  let queryTx = '';
		  if (utm_source && utm_name && utm_content) {
		  	queryTx = `?utm_source=${utm_source}&utm_name=${utm_name}&utm_content=${utm_content}`
		  }
        location.replace(`${location.origin}${this.$FORWARD_BASE_PATH}/#/mini/login${queryTx}`)
      }else{
		  // 存储utm
		  this.uploadUtm();
	  }
      this.isWexin = window.isWexin

      if (!window.isWxWork && !window.isLark) {

        this.$store.dispatch('actionWechatTicket', location.href.split('#')[0])
          .then(res => {
            return new Promise((resolve, reject) => {
              console.log('$wx-config', this.$wx)
              this.$wx.config({
                // debug: true,
                appId: res.appId,
                timestamp: res.timestamp,
                nonceStr: res.nonceStr,
                signature: res.signature,
                jsApiList: ['scanQRCode', 'getLocation', 'chooseImage', 'getLocalImgData'],
                openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
              })
              this.$wx.ready(resolve)
              this.$wx.error(reject)
            })
          })
          .catch(err => {
            console.error('wx config error:', err)
          })
      }
	  
    },
    computed: {
      loginBgImage () {
        return this.$store.getters.configMap.logoBgUrl
      }
    },
    methods: {
      onClickApp() {
        const toast = this.$toast.loading({message: '加载中...'})
        this.$store.dispatch('reqNodeSave', {
          canBack: 0,
          installShowQrcode: 1
        })
          .then(res => {
            this.$router.push({
              name: 'templateList',
              query: {
                key: res.nodeKey
              }
            })
          })
          .catch(err => {
            console.error(err)
          })
          .finally(() => {
            toast.clear()
          })
      },
      onClickLogin() {

        this.$dialog.confirm({
          title:'提示',
          message: '当前浏览器不支持登录，请复制链接在微信浏览器中打开。',
          confirmButtonText: '复制',
          cancelButtonText: '取消'
        }).then(() => {

          this.copyInput.setAttribute('value', location.href)
          this.copyInput.select()
          const result = document.execCommand(`copy`)
          if (result) {
            this.$toast.success(`复制成功`)
          } else {
            this.$toast.fail(`复制失败`)
          }

        }).catch(action => {
        })
      },

      onLaunch() {
        console.error('onLaunch')
      },
      onError(err) {
        console.error('onError', err)
      },
	  uploadUtm() {
	  	const {
	  		utm_source,
	  		utm_name,
	  		utm_content,
			utm_page
	  	} = this.$route.query
	  
	  	if (isUndefined(utm_source) && isUndefined(utm_name) && isUndefined(utm_content) && isUndefined(utm_page)) {
	  		return
	  	}
	  
	  	this.$store.dispatch('getIp', {}).then((res) => {
	  		var utmUserIp = res.ip,
	  			utmApplicationDate = res.utmApplicationDate,
	  			dateFormat = 'yyyy-MM-dd HH:mm:ss',
	  			browserType = BrowserType(),
				utmPage = utm_page == 'login'?'登录':'注册',
	  			utmUserAddress = {
	  				province: res.province,
	  				city: res.city,
	  				county: res.district,
	  				detailAddress: res.addressDetail,
	  				longitude: res.longitude,
	  				latitude: res.latitude
	  			}
	  
	  		// 推广名称编号：utmPromoteCode
	  		// 来源编号：utmSourceCode
	  		// 推广内容:utmContent
	  		// 落地页面:utmPage(登录，注册，应用模板)
	  		// 访问者ip：utmUserIp
	  		// 申请时间：utmApplicationDate
	  		// 设备类型：utmEquipmentType(pc，移动端)
	  		// 系统：utmSystemType
	  		// 更新时间：utmUpdateTime
	  
	  		this.$store.dispatch('utmUploadParam', {
	  			utmSourceCode: utm_source,
	  			utmPromoteCode: utm_name,
	  			utmContent: utm_content,
	  			utmPage: utmPage,
	  			utmUserIp: utmUserIp,
	  			utmApplicationDate: formatDate(Date.parse(utmApplicationDate))(dateFormat),
	  			utmEquipmentType: '移动端',
	  			utmSystemType: browserType.system,
	  			utmBrowser: browserType.supporter,
	  			utmUpdateTime: formatDate(+new Date())(dateFormat),
	  			utmUserAddress: utmUserAddress
	  		}).catch(console.error).finally(() => {
	  			console.log('utm执行完毕')
	  		})
	  	}).catch(console.error)
	  },
    }
  }
</script>

<style lang="less">

  .forward-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    overflow-y: auto;

    .login-image {
      width: 300px;
      height: auto;
      margin: 20px 0;
	  object-fit: cover;
    }


    .title {
      font-size: 28px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    .sub-title {
      font-size: 16px;
      color: #282828;
      margin-bottom: 10px;
    }

    .footer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 40px;

      .van-button {
        width: 150px;
      }

      .weapp-btn {
        height: 44px;
        line-height: 44px;
        width: 150px;
      }
    }
  }
</style>
